// src/store/slices/settingsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../config/api";
import { Pagination } from "react-bootstrap";

export const fetchSettings = createAsyncThunk(
  "settings/fetchSettings",
  async (week_id, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state



      const response = await axios.get(
        `${API_URL}/restaurant/trainee/settings`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const fetchAdminSettings = createAsyncThunk(
  "settings/fetchAdminSettings",
  async (week_id, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state



      const response = await axios.get(
        `${API_URL}/restaurant/admin/settings`,
        
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const fetchSetting = createAsyncThunk(
  "settings/fetchSetting",
  async (resturantID, thunkAPI) => {
    
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state



      const response = await axios.get(
        `${API_URL}/setting/admin/settings/${resturantID}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );
console.log(response.data.data);

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const addSetting = createAsyncThunk(
  "settings/addSetting",
  async (settingData, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(`${API_URL}/restaurant/admin/settings`, settingData, {
        headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      return response.data.data;
    } catch (error) {

    return thunkAPI.rejectWithValue(Object.values(error.response.data.errors)[0][0] || "فشل إضافة الصف");
    }
  }
);
export const updateSetting = createAsyncThunk(
  "settings/updateSetting",
  async (settingData, thunkAPI) => {
    console.log(settingData,"settingData");
    
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.put(`${API_URL}/setting/admin/settings/${settingData?.id}`, {name:settingData?.name}, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      console.log(response.data.data);
      
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);export const deleteSetting = createAsyncThunk(
  "settings/deleteSetting",
  async (settingID, thunkAPI) => {
    console.log(settingID,"settingData");
    
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.delete(`${API_URL}/setting/admin/settings/${settingID}`, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      console.log(response.data.data);
      
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);

const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    list: [],
      singleSetting: null,
Pagination:null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAdminSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchAdminSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      
      
      
      
      
      
      
      
      
      .addCase(fetchSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.singleSetting = action.payload;
      })
      .addCase(fetchSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      
      .addCase(addSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSetting.fulfilled, (state, action) => {
        state.loading = false;
        // state.list.push(action.payload);
      })
      .addCase(addSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(updateSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload);
      })
      .addCase(updateSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(deleteSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSetting.fulfilled, (state, action) => {
        state.loading = false;
        // state.list.push(action.payload);
      })
      .addCase(deleteSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  },
});

export default settingsSlice.reducer;
